import { AddCopyFormSection } from "./AddCopyFormSection";
import type { ItemCopyData } from "./CopyDetailsEditor";
import type { CatalogSettings, CreateCatalogRequest } from "@/lib/api/catalog";
import { useActiveBranches } from "@/hooks/useActiveBranches";
import { useBookConditions } from "@/hooks/useBookConditions";
import { useCollections } from "@/hooks/useCollections";
import { useItemStatuses } from "@/hooks/useItemStatuses";
import { useItemTypes } from "@/hooks/useItemTypes";
import { useLocations } from "@/hooks/useLocations";

type ItemDefaults = CreateCatalogRequest["itemDefaults"];

interface ReceiveIssueCopySectionProps {
  copies: number;
  onCopiesChange: (copies: number) => void;
  copyData: ItemCopyData[];
  onCopyDataChange: (copies: ItemCopyData[]) => void;
  itemDefaults: ItemDefaults;
  onItemDefaultsChange: (defaults: ItemDefaults) => void;
  onSubmit: () => void;
  loading: boolean;
  catalogSettings: CatalogSettings;
}

export function ReceiveIssueCopySection(props: ReceiveIssueCopySectionProps) {
  const { data: itemTypes = [] } = useItemTypes(false);
  const { data: locations = [] } = useLocations(false);
  const { data: collections = [] } = useCollections(false);
  const { data: conditions = [] } = useBookConditions(false);
  const { data: itemStatuses = [] } = useItemStatuses();
  const { data: branches = [] } = useActiveBranches();

  return (
    <AddCopyFormSection
      {...props}
      itemTypes={itemTypes}
      locations={locations}
      collections={collections}
      conditions={conditions}
      itemStatuses={itemStatuses}
      branches={branches}
      submitLabel="Receive issue"
    />
  );
}
